"use strict";
/*=======================================
  IntersectionObserver系
=======================================*/
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.getRandomInteger = exports.removeClass = exports.addClass = exports.hasClass = exports.qsAll = exports.qs = exports.isActive = exports.getPathHash = exports.getHash = exports.getPath = exports.getParam = exports.setFooterHeightCP = exports.getHeaderHeight = exports.scrollToOffset = exports.toggleClass = exports.setStaticSvh = exports.setSvh = exports.initMousemoveAnimation = exports.initPaperAnimation = exports.initParallax = exports.scrollHint = exports.smoothScroll = exports.humbergerMenuUtils = exports.changeCharacterFace = exports.disableFvProps = exports.setCurrentSection = exports.ISOvserveRepeat = exports.ISOvserve = void 0;
// IntersectionObserver共通関数
function ISOvserver(targetSelectors, options, ifFunc, elseFunc = () => { }) {
    const targets = qsAll(targetSelectors.join(", "));
    if (targets) {
        let observer = new IntersectionObserver(callback(ifFunc, elseFunc), options);
        for (const elm of targets) {
            observer.observe(elm);
        }
    }
    function callback(ifFunc, elseFunc) {
        return function (entries) {
            for (const elm of entries) {
                if (elm.isIntersecting) {
                    ifFunc(elm);
                }
                else {
                    elseFunc(elm);
                }
            }
        };
    }
}
function ISOvserve() {
    const targetSelectors = [".c__js_fade", ".c__js_blur", ".js__transition", ".js__animation", ".js__observe", ".c__js_highlights"];
    // ネガティブマージンにすると当たり判定を狭められて、
    // 普通のマージンにすると当たり判定を画面外まで広げられる
    const options = {
        rootMargin: "0% 0% -40% 0%", // ビューポートの真ん中ぐらい
    };
    function ifFunc(elm) {
        elm.target.classList.add("active");
    }
    ISOvserver(targetSelectors, options, ifFunc);
}
exports.ISOvserve = ISOvserve;
function ISOvserveRepeat() {
    const targetSelectors = [".js__observe_repeat"];
    const options = {
        rootMargin: "0% 0% -40% 0%", // ビューポートの真ん中ぐらい
    };
    function ifFunc(elm) {
        elm.target.classList.add("active");
    }
    function elseFunc(elm) {
        elm.target.classList.remove("active");
    }
    ISOvserver(targetSelectors, options, ifFunc, elseFunc);
}
exports.ISOvserveRepeat = ISOvserveRepeat;
function setCurrentSection() {
    const targetSelectors = ["#concept", "#merits", "#plans", "#offices", "#profile"];
    const options = {
        rootMargin: "-10% 0% -90% 0%", // 画面のかなり上のほうまで来たら
    };
    function ifFunc(elm) {
        addClass(qs("#js__menu_" + elm.target.id), "active");
    }
    function elseFunc(elm) {
        removeClass(qs("#js__menu_" + elm.target.id), "active");
    }
    ISOvserver(targetSelectors, options, ifFunc, elseFunc);
}
exports.setCurrentSection = setCurrentSection;
function disableFvProps() {
    const targetSelectors = ["#first_view"];
    const options = {
        rootMargin: "-60% 0% 0% 0%", // ビューポートの真ん中ぐらいを通り過ぎたら
    };
    function ifFunc() {
        removeClass(qs("#concept"), "active");
        removeClass(qs("#js__character_bg_props"), "disabled");
        removeClass(qs("#js__copy_r"), "disabled");
        removeClass(qs("#js__copy_l"), "disabled");
    }
    function elseFunc() {
        addClass(qs("#concept"), "active");
        addClass(qs("#js__character_bg_props"), "disabled");
        addClass(qs("#js__copy_r"), "disabled");
        addClass(qs("#js__copy_l"), "disabled");
    }
    ISOvserver(targetSelectors, options, ifFunc, elseFunc);
}
exports.disableFvProps = disableFvProps;
function changeCharacterFace() {
    const targetSelectors = [".js__anxiety_observer"];
    const options = {
        rootMargin: "0% 0% -70% 0%", // 画面のかなり上のほうまで来たら
    };
    function ifFunc() {
        addClass(qs("#js__character_anxiety"), "active");
        addClass(qs(".js__anxiety_observer"), "active");
    }
    function elseFunc() {
        removeClass(qs("#js__character_anxiety"), "active");
        removeClass(qs(".js__anxiety_observer"), "active");
    }
    ISOvserver(targetSelectors, options, ifFunc, elseFunc);
}
exports.changeCharacterFace = changeCharacterFace;
/*=======================================
  ハンバーガーメニューまわり
=======================================*/
function humbergerMenuUtils() {
    const toggle = qs("#header_toggle");
    const spMenu = qs("#sp_menu");
    const overlay = qs("#overlay");
    toggle.addEventListener("click", () => {
        toggleMenu();
    });
    overlay.addEventListener("click", () => {
        toggleMenu();
    });
    const spMenuLinks = qsAll("a", spMenu);
    for (const elm of spMenuLinks) {
        elm.addEventListener("click", () => {
            toggleMenu();
        });
    }
}
exports.humbergerMenuUtils = humbergerMenuUtils;
function toggleMenu() {
    const toggle = qs("#header_toggle");
    const spMenu = qs("#sp_menu");
    const overlay = qs("#overlay");
    toggleClass(toggle, "active");
    toggleClass(spMenu, "active");
    toggleClass(overlay, "active");
    if (hasClass(toggle, "active")) {
        preventScroll();
    }
    else {
        arrowScroll();
    }
}
function preventScroll() {
    document.addEventListener("wheel", preventDef, { passive: false });
    document.addEventListener("touchmove", preventDef, { passive: false });
}
function arrowScroll() {
    document.removeEventListener("wheel", preventDef);
    document.removeEventListener("touchmove", preventDef);
}
// スクロール禁止関数
function preventDef(e) {
    e.preventDefault();
}
/*=======================================
  スムーススクロール系
=======================================*/
function smoothScroll() {
    const scrollAnchor = qsAll('a[href^="#"]');
    const scrollAnchorArr = Array.prototype.slice.call(scrollAnchor);
    let targetId;
    let targetOffsetTop;
    // ページ内でのアンカーの場合
    for (const link of scrollAnchorArr) {
        link.addEventListener('click', (e) => {
            console.log("link");
            e.preventDefault();
            targetId = link.hash;
            if (targetId) {
                let targetElement = qs(targetId);
                targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top;
            }
            else {
                targetOffsetTop = 0;
            }
            window.scrollTo({
                top: targetOffsetTop,
                behavior: "smooth"
            });
        });
    }
    // ページ外からのアンカーの場合
    const anchorId = location.hash;
    if (anchorId.indexOf("#") != -1) {
        let target = qs(anchorId);
        let position = window.pageYOffset + target.getBoundingClientRect().top;
        window.scrollTo({
            top: position,
            behavior: "smooth"
        });
    }
    // ページトップボタンの場合
    const top = qs('#first_view');
    const pagetopButton = qs('#pagetop_button');
    const options = {
        rootMargin: "170px 0px 0px 0px",
    };
    const observer = new IntersectionObserver((entries) => {
        for (const e of entries) {
            if (e.isIntersecting) {
                pagetopButton.classList.remove('active');
            }
            else {
                pagetopButton.classList.add('active');
            }
        }
    }, options);
    observer.observe(top);
    pagetopButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    });
}
exports.smoothScroll = smoothScroll;
/*=======================================
  スクロールヒント
=======================================*/
const scroll_hint_1 = __importDefault(require("scroll-hint"));
require("scroll-hint/css/scroll-hint.css");
function scrollHint() {
    new scroll_hint_1.default('.js-scrollable', {
        suggestiveShadow: true,
        i18n: {
            scrollable: 'スクロールできます'
        }
    });
}
exports.scrollHint = scrollHint;
/*=======================================
  パララックス処理
=======================================*/
function initParallax() {
    const parallaxTargets = qsAll('.js__parallax_container');
    const isLandscape = (window.innerWidth - window.innerHeight) > 0; // 端末が横長かどうか
    for (const elm of parallaxTargets) {
        let magnifClass = elm.className.match(/js__parallax_magnif_./);
        let magnif = magnifClass ? Number(magnifClass[0].slice(-1)) : 1;
        window.addEventListener("scroll", () => { parallax(elm, magnif); });
    }
    function parallax(elm, magnif) {
        const base = 0.3;
        const fff = base * magnif;
        const parallaxMagnification = isLandscape ? fff : fff / 2; // 端末が縦長だった場合は倍率を低くする
        elm.style.transform = `translateY(-${window.pageYOffset * parallaxMagnification}px)`;
    }
}
exports.initParallax = initParallax;
/*=======================================
  FV背景の紙のアニメーション生成
=======================================*/
function initPaperAnimation() {
    let parallaxTargets = qsAll('.paper');
    for (const elm of parallaxTargets) {
        const delay = getRandomInteger(0, 3, -1) * 1.5; // s
        const duration = getRandomInteger(16, 26); // s
        elm.style.animation = `${duration}s ease ${delay}s infinite normal none running paper_animation`;
    }
}
exports.initPaperAnimation = initPaperAnimation;
/*=======================================
  FVでマウスを動かした際のアニメーション
=======================================*/
function initMousemoveAnimation() {
    // 画面の中心を求める
    let originX = window.innerWidth / 2;
    let originY = window.innerHeight / 2;
    const begumaruNode = qsAll('.prop');
    let magnif = [];
    let i = 0;
    for (const elm of begumaruNode) {
        magnif.push(0.04 * getRandomInteger(2, 5, i));
    }
    window.addEventListener('mousemove', (e) => {
        // 画面の中心からのオフセット
        // e.clientX と e.clientY でマウスの位置座標を取得
        // マウスと逆に動くよう正負を反転
        let offsetX = (e.clientX - originX) * -1;
        let offsetY = (e.clientY - originY) * -1;
        i = 0;
        for (const elm of begumaruNode) {
            let x = round(offsetX * magnif[i], 1);
            let y = round(offsetY * magnif[i], 1);
            elm.style.transform = `translate(${x}px, ${y}px)`;
            i++;
        }
    });
}
exports.initMousemoveAnimation = initMousemoveAnimation;
/*=======================================
  その他関数
=======================================*/
function setSvh() {
    setTimeout(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--svh', `${vh}px`);
    }, 500);
}
exports.setSvh = setSvh;
function setStaticSvh() {
    setTimeout(() => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--static_svh', `${vh}px`);
    }, 500);
}
exports.setStaticSvh = setStaticSvh;
function toggleClass(element, className) {
    if (element.className.includes(className)) {
        element.classList.remove(className);
    }
    else {
        element.classList.add(className);
    }
}
exports.toggleClass = toggleClass;
function scrollToOffset(offset) {
    window.scrollTo({
        top: offset,
        behavior: "smooth"
    });
}
exports.scrollToOffset = scrollToOffset;
function getHeaderHeight() {
    const pc_header_selector = "#header .header_l";
    const sp_header_selector = "#sp_menu .sp_menu_logo";
    const pcHeaderHeight = qs(pc_header_selector).offsetHeight;
    const tabHeaderHeight = qs(sp_header_selector).offsetHeight;
    return pcHeaderHeight + tabHeaderHeight + 40;
}
exports.getHeaderHeight = getHeaderHeight;
// フッターの高さをカスタムプロパティにセット
function setFooterHeightCP() {
    const footer_selector = "#footer";
    const footerHeight = qs(footer_selector).offsetHeight;
    document.documentElement.style.setProperty('--footer_height', `${footerHeight}px`);
}
exports.setFooterHeightCP = setFooterHeightCP;
function getParam(param) {
    let url = new URL(window.location.href);
    let value = url.searchParams.get(param);
    return value ? value : "";
}
exports.getParam = getParam;
function getPath() {
    return window.location.pathname;
}
exports.getPath = getPath;
function getHash() {
    return window.location.hash;
}
exports.getHash = getHash;
function getPathHash() {
    return window.location.pathname + window.location.hash;
}
exports.getPathHash = getPathHash;
function isActive(element) {
    return element.className.includes("active");
}
exports.isActive = isActive;
function qs(name, elm = document) {
    return elm.querySelector(name);
}
exports.qs = qs;
function qsAll(name, elm = document) {
    return elm.querySelectorAll(name);
}
exports.qsAll = qsAll;
function hasClass(elm, name) {
    return elm.className.includes(name);
}
exports.hasClass = hasClass;
function addClass(elm, name) {
    if (elm)
        elm.classList.add(name);
}
exports.addClass = addClass;
function removeClass(elm, name) {
    if (elm && hasClass(elm, name)) {
        elm.classList.remove(name);
    }
}
exports.removeClass = removeClass;
/**
* ランダムな正の整数を生成
* @param {number} min - 最小値
* @param {number} max - 最大値
* @param {number} offset - 結果を若干上振れor下振れさせたい場合に使用
* @return {number} ランダムな整数
* @note offsetに小数を渡した場合は小数が返却される
* @note 0が返却される可能性もあり
*/
function getRandomInteger(min, max, offset = 0) {
    const num = (Math.floor(Math.random() * (max + 1 - min)) + min) + offset;
    return num <= 0 ? 0 : num;
}
exports.getRandomInteger = getRandomInteger;
/**
* 小数点の桁数をを指定し、四捨五入して返す
* @param {number} number - 対象となる数値
* @param {number} digit - 小数点の桁数
* @return {number} 四捨五入した値
* @note Math.pow() は累乗を算出する関数で、 Math(x, y) はxのy乗を表す
*/
function round(number, digit) {
    const magnification = Math.pow(10, digit);
    return Math.round(number * magnification) / magnification;
}
exports.round = round;
;
